import { defineComponent as r, provide as n, renderSlot as i } from "vue";
const a = /* @__PURE__ */ r({
  name: "e-config-provider",
  __name: "config-provider",
  props: {
    locale: {},
    coinBaseUrl: {}
  },
  setup(o) {
    return n(t, o), (e, c) => i(e.$slots, "default");
  }
}), t = Symbol("ConfigProvider");
export {
  t as configProviderInjectionKey,
  a as default
};
//# sourceMappingURL=config-provider.js.map
